import { render, staticRenderFns } from "./StaticPageView.vue?vue&type=template&id=3f015d7f"
import script from "./StaticPageView.vue?vue&type=script&lang=js"
export * from "./StaticPageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports